import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface GeneralProps {
    openDeleteListingModal: boolean,
    openProfileSettingsModal: boolean,
    openAccountModal: boolean,
    openUpdatePaymentModal: boolean,
    updateListing: Boolean
    pageUrl: string
    upgrade: Boolean
    showModal: Boolean
  }

const initialState: GeneralProps = {
    openDeleteListingModal: false,
    openProfileSettingsModal: false,
    openAccountModal: false,
    openUpdatePaymentModal: false,
    updateListing: false,
    pageUrl: '',
    upgrade: false,
    showModal: false
}

const GeneralSlice = createSlice({
    name: 'General',
    initialState,
    reducers:{
        setOpenModal(state, action: PayloadAction<boolean>) {
            state.openDeleteListingModal = action.payload;
        },
        setUpdateListing(state, action: PayloadAction<boolean>) {
            state.updateListing = action.payload;
        },
        setUpgrade: (state, action) => {
            state.upgrade = action.payload
        },
        setProfileSettingsModal(state, action: PayloadAction<boolean>) {
            state.openProfileSettingsModal = action.payload
        },
        setOpenAccountModal(state, action: PayloadAction<boolean>) {
            state.openAccountModal = action.payload
        },
        setOpenUpdatePaymentModal(state, action: PayloadAction<boolean>) {
            state.openUpdatePaymentModal = action.payload
        },
        showModal: (state) => {
            state.showModal = true;
        },
        resetModal: (state) => {
            state.showModal = false;
        },
    }
})

export const {setOpenModal, setUpdateListing, setUpgrade, setProfileSettingsModal, setOpenAccountModal, setOpenUpdatePaymentModal, showModal, resetModal} = GeneralSlice.actions;
export default GeneralSlice.reducer
